/** Transmitted Codat SignalR web socket message data types */
export enum CodatDataType {
  /** Only transmitted during the initial accounting software connection process. Signals completion of the initial connection process (but not the sync process). */
  Company = 'company',
  /** Only transmitted during the initial accounting software connection process. Signals completion of the initial connection process (but not the sync process). */
  Currencies = 'currencies',
  /** Transmitted during sync process */
  Bills = 'bills',
  /** Transmitted during sync process */
  Customers = 'customers',
  /** Transmitted during sync process */
  Invoices = 'invoices',
  /** Transmitted during sync process */
  Suppliers = 'suppliers',
  BankAccounts = 'bankAccounts',
  CreditNotes = 'creditNotes',
  TrackingCategories = 'trackingCategories',
  TaxRates = 'taxRates',
  ChartOfAccounts = 'chartOfAccounts',
  BillCreditNotes = 'billCreditNotes',
  Payments = 'payments',
  Items = 'items',
}

/** Codat web socket sync messages */
export type CodatSyncMessage = {
  dataTypes: Array<CodatDataType>;
  companyId: string;
};
